// routes.jsx
import { Routes, Route, Navigate } from "react-router-dom";
import AdminPanel from "../layouts/AdminPanel";
import DashboardAdmin from "../pages/dashboard/DashboardAdmin";
import ClientesAdmin from "../pages/customer/ClientesAdmin";
import CalidadPanel from "../pages/CalidadPanel";
import BackRecuperoPanel from "../pages/BackRecuperoPanel";
import { NoAutorizado } from "../pages/errors/NoAutorizado";
import RutaProtegida from "../router/RutaProtegida";
import { NoFound } from "../pages/errors/NoFound";
import PasswordRecovery from "../pages/auth/PasswordRecovery";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import Login from "../pages/auth/Login";
import AjustesAdmin from "../pages/settings/AjustesAdmin";
import UsuariosAdmin from "../pages/users/UsuariosAdmin";
import ModificarVenta from "../pages/sales/ModificarVenta";
import VentasAdmin from "../pages/sales/VentasAdmin";
import ReportadasAdmin from "../pages/reported/ReportadasAdmin";
import RegistrarReportada from "../pages/reported/RegistrarReportada";
import ReporteVentas from "../pages/sales/report/ReporteVentas";
import NuevaVenta from "../pages/sales/NuevaVenta";
import ConsultarVenta from "../pages/sales/ConsultarVenta";
import ProductosAdmin from "../pages/products/ProductosAdmin";
import NuevoProducto from "../pages/products/NuevoProducto";
import ActualizarProducto from "../pages/products/ActualizarProducto";
import ReclutamientoAdmin from "../pages/recruitment/ReclutamientoAdmin";
import NuevoPostulante from "../pages/recruitment/NuevoPostulante";
import UpdatePostulante from "../pages/recruitment/UpdatePostulante";
import EntrevistaForm from "../pages/recruitment/EntrevistaForm";
import RRHHAdmin from "../pages/rrhh/RRHHAdmin";
import NuevoUsuario from "../pages/rrhh/NuevoUsuario";
import LowRequestAdmin from "../pages/lowrequest/LowRequestAdmin";
import AsistenciaAdmin from "../pages/attendance/AsistenciaAdmin";
import SupportAdmin from "../pages/support/SupportAdmin";
import ConsultarSupport from "../pages/support/ConsultarSupport";
import WelcomeAdmin from "../pages/welcome/WelcomeAdmin";
import RegistrarWelcome from "../pages/welcome/RegistrarWelcome";

const AppRoutes = () => {
  const { usuario, token, handleLogout } = useContext(AuthContext);
  return (
    <Routes>
      <Route
        path="/admin"
        element={
          usuario ? (
            <AdminPanel
              user={usuario}
              token={token}
              onLogout={handleLogout}
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route
          index
          element={
            <RutaProtegida permiso="menu_dashboard">
              <DashboardAdmin token={token} />{" "}
            </RutaProtegida>
          }
        />
        <Route
          path="usuarios"
          element={
            <RutaProtegida permiso="menu_users">
              <UsuariosAdmin token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="rrhh"
          element={
            <RutaProtegida permiso="menu_rrhh">
              <RRHHAdmin token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="solicitudbaja"
          element={
            <RutaProtegida permiso="menu_low_request">
              <LowRequestAdmin token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="reclutamiento"
          element={
            <RutaProtegida permiso="menu_recruitment">
              <ReclutamientoAdmin token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="reclutamiento/registrar"
          element={
            <RutaProtegida permiso="recruitment_add">
              <NuevoPostulante token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="reclutamiento/:id"
          element={
            <RutaProtegida permiso="recruitment_edit"> 
              <UpdatePostulante token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="reclutamiento/entrevista/:id"
          element={
            <RutaProtegida permiso="recruitment_entrevistar">
              <EntrevistaForm token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="rrhh/contratar/:id"
          element={
            <RutaProtegida permiso="rrhh_create_user">
              <NuevoUsuario token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="productos"
          element={
            <RutaProtegida permiso="menu_products">
              <ProductosAdmin token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="soporte"
          element={
            <RutaProtegida permiso="menu_soporte">
              <SupportAdmin token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="ventas"
          element={
            <RutaProtegida permiso="menu_sales">
              <VentasAdmin token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="bienvenida"
          element={
            <RutaProtegida permiso="menu_welcome">
              <WelcomeAdmin token={token} user={usuario} />
            </RutaProtegida>
          }
        />
         <Route
          path="bienvenida/registrar/:id/:j?"
          element={
            <RutaProtegida permiso="menu_welcome">
              <RegistrarWelcome token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="reportadas"
          element={
            <RutaProtegida permiso="menu_reported">
              <ReportadasAdmin token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="reportadas/registrar/:id/:j?"
          element={
            <RutaProtegida permiso="consultar_venta">
              <RegistrarReportada token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="reportes"
          element={
            <RutaProtegida permiso="menu_reports">
              <ReporteVentas token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="asistencia"
          element={
            <RutaProtegida permiso="menu_asistencia">
              <AsistenciaAdmin token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="historial"
          element={
            <RutaProtegida permiso="menu_historial">
              <ReporteVentas token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="clientes"
          element={
            <RutaProtegida permiso="menu_customers">
              <ClientesAdmin token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="seguimiento"
          element={
            <RutaProtegida permiso="menu_follow">
              <CalidadPanel />
            </RutaProtegida>
          }
        />
        <Route
          path="perfiles"
          element={
            <RutaProtegida permiso="menu_settings">
              <AjustesAdmin token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="recupero"
          element={
            <RutaProtegida permiso="menu_recover">
              <BackRecuperoPanel />
            </RutaProtegida>
          }
        />
        <Route
          path="ventas/:id"
          element={
            <RutaProtegida permiso="update_venta">
              <ModificarVenta token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="ventas/consultar/:id"
          element={
            <RutaProtegida permiso="consultar_venta">
              <ConsultarVenta token={token} user={usuario} />
            </RutaProtegida>
          }
        />
         <Route
          path="soporte/consultar/:id"
          element={
            <RutaProtegida permiso="view_soporte_detail">
              <ConsultarSupport token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="ventas/registrar"
          element={
            <RutaProtegida permiso="create_venta">
              <NuevaVenta token={token} user={usuario} />
            </RutaProtegida>
          }
        />
        <Route
          path="productos/:id"
          element={
            <RutaProtegida permiso="edit_product">
              <ActualizarProducto token={token} />
            </RutaProtegida>
          }
        />
        <Route
          path="productos/registrar"
          element={
            <RutaProtegida permiso="add_products">
              <NuevoProducto token={token} />
            </RutaProtegida>
          }
        />
      </Route>
      <Route path="/" element={
        usuario ? (
          <Navigate to="/admin" replace />
        ) : (
          <Login />
        )
      } />
      <Route path="/recuperar-clave" element={<PasswordRecovery />} />
      <Route path="/no-autorizado" element={<NoAutorizado />} />
      <Route path="*" element={<NoFound />} />
    </Routes>
  );
};

export default AppRoutes;
